@if (isOpen) {
  <div class="modal" [ngClass]="modalCssClass">
    <div class="modal-overlay" (click)="onOverlayClick()"></div>
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-title">
          <h2>{{ headline }}</h2>
          @if (subHeadline) {
            <p>{{ subHeadline }}</p>
          }
        </div>
        @if (isCloseable) {
          <div class="modal-close">
            <gene-close-icon
              [width]="isMobile ? '16px' : '24px'"
              [height]="isMobile ? '16px' : '24px'"
              fill="#1B1B1D"
              (click)="closeModal()"
              />
          </div>
        }
      </div>
      <div class="modal-body">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
}
